import { ZfDivider } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useGeneralSimulationSettings } from '../../../hooks/useGeneralSimulationSettings';
import { InflationSlider } from './InflationSlider';
import { MonteCarloGeneralCustomSettings } from './MonteCarloGeneralCustomSettings';
import { MonteCarloGeneralDefaultSettings } from './MonteCarloGeneralDefaultSettings';
import { ProjectionPeriodSlider } from './ProjectionPeriodSlider';
import { ScenarioSwitch } from './ScenarioSwitch';

const sliderPadding = 'var(--padding-vertical-md) var(--padding-horizontal-xs)';

export const MonteCarloGeneralSettings: FunctionComponent = () => {
    const { settings } = useGeneralSimulationSettings();

    return settings?.projectionPeriodYears ? (
        <>
            <ScenarioSwitch />
            <ZfDivider />
            <ProjectionPeriodSlider />
            <ZfDivider />
            {settings?.scenario === 'DEFAULT' && <MonteCarloGeneralDefaultSettings padding={sliderPadding} />}
            {settings?.scenario === 'CUSTOM' && <MonteCarloGeneralCustomSettings padding={sliderPadding} />}
            <ZfDivider />
            <InflationSlider padding={sliderPadding} />
        </>
    ) : null;
};
